import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {SubjectTestListComponent} from './subject-test-list/subject-test-list.component';
import {SubjectListComponent} from './subject-list/subject-list.component';
import {SubjectTestComponent} from './subject-test/subject-test.component';
import {CoursePermissionComponent} from '../courses/course-permission/course-permission.component';
import {SubjectTestPermissionComponent} from './subject-test-permission/subject-test-permission.component';

const routes: Routes = [
  {
    path: 'subject-list',
    component: SubjectListComponent,
  },
  {
    path: 'subject-test-list/:lesson',
    component: SubjectTestListComponent,
  },
  {
    path: 'subject-test/:id',
    component: SubjectTestComponent,
  },
  {
    path: 'subject-test/:id/permission',
    component: SubjectTestPermissionComponent,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SubjectTestsRoutingModule {
}
